import styled from '@emotion/styled';
import {
  lineItemsCellContainerStyle,
  lineItemsShowMoreButton,
  lineItemsTableSharedCss,
} from '@/common/LineItems/v1SharedStyles';

export const cellContainerStyle = lineItemsCellContainerStyle;
export const ShowMoreButton = lineItemsShowMoreButton;

export const LineItemsWrapper = styled.div<{ showMoreButtonShown: boolean }>`
  ${({ showMoreButtonShown }) => lineItemsTableSharedCss(showMoreButtonShown)}
  & th:first-of-type,
  & td:first-of-type {
    width: 60%;
  }
  & th:nth-of-type(2),
  & td:nth-of-type(2) {
    width: 110px;
  }
  & th:nth-of-type(3),
  & td:nth-of-type(3) {
    width: 110px;
  }
  & th:nth-of-type(4),
  & td:nth-of-type(4) {
    width: 110px;
  }
`;
